/** @format */

import React, { FunctionComponent, useMemo } from 'react';
import PlatformUser from '../../interfaces/platform/PlatformUser';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { history } from '../../core/history';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { platformUserConstants } from '../../modules/platformuser/actions';
import { PlatformUserModify, PlatformUserSendType } from './PlatformUserModify';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { DateHelperTs } from '../../helpers/DateHelperTs';

export type PlatformUserAddType = {
    match: any;
};

export const PlatformUserAdd: FunctionComponent<PlatformUserAddType> = ({ match }): React.ReactElement => {
    const dispatch = useDispatch();
    const resellerId = useMemo((): string | null => {
        return match?.params?.id;
    }, [match]);

    const savePlatformUser = (outputObject: PlatformUserSendType, errors?: Array<string>): void => {
        if (!resellerId) {
            return;
        }

        outputObject.platformResellerId = parseInt(resellerId);
        if (outputObject.newPassword === '') {
            outputObject.newPassword = null;
        }
        const sendOutputObject: PlatformUserSendType = outputObject;
        if (!sendOutputObject.activatedAt || sendOutputObject.activatedAt === null || sendOutputObject.activatedAt === '') {
            sendOutputObject.activatedAt = DateHelperTs.getCurrentDateTime();
        }

        if (errors && errors?.length > 0) {
            errors?.forEach((el: any) => {
                NotificationHelper.notifyError(el, dispatch);
            });

            return;
        }
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.postWithCallback(
            FormGeneralHelper.getUrl('/platform_users', 'platform'),
            platformUserConstants.SAVE_ITEM,
            sendOutputObject,
            (data: PlatformUser): void => {
                // const uri = FormGeneralHelper.getByUri(data['@id']);
                // const redirectUri = FormGeneralHelper.getRouteUrl('/platform-user-edit/' + uri);

                const redirectUri = FormGeneralHelper.getRouteUrl('/platform-user-edit/' + data['@id']);
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                history.push(redirectUri);
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    return <PlatformUserModify resellerId={resellerId} savePlatformUser={savePlatformUser} />;
};
